import React from 'react';

type FormErrorPasswordResetProps = {
  message: string;
  passwordResetText: string;
  passwordResetLink: string;
};

export const FormErrorPasswordReset = ({
  message,
  passwordResetText,
  passwordResetLink,
}: FormErrorPasswordResetProps) => {
  return (
    <div data-testid="formerror-passwordreset">
      <p data-testid="passwordreset-message">
        {message}
        <a data-testid="passwordreset-link" href={passwordResetLink}>
          {passwordResetText}
        </a>
      </p>
    </div>
  );
};
